"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var defaultStyles = function (theme) {
    return {
        root: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        splitter: {
            cursor: "ns-resize",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            backgroundColor: theme.palette.themeDark,
            left: 0,
            right: 0
        },
        splitterHandle: {
            position: "absolute",
            top: -2,
            right: 0,
            bottom: -2,
            left: 0,
            overflow: "hidden",
            backgroundColor: "transparent",
            color: theme.palette.themeDark,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
            transition: "background-color 0.3s ease",
            selectors: {
                ":hover": {
                    backgroundColor: theme.palette.themeDark,
                    opacity: 0.5,
                },
                ".vsplit-icon": {
                    fontSize: styling_1.FontSizes.mini,
                    visibility: "hidden",
                    color: theme.palette.white
                },
                "&.active": {
                    backgroundColor: theme.palette.themeDark,
                    opacity: 1.0,
                    selectors: {
                        ".vsplit-icon": {
                            visibility: "visible"
                        }
                    }
                }
            }
        },
        topPane: {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            overflow: "hidden"
        },
        topContent: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            overflow: "auto"
        },
        bottomPane: {
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            overflow: "hidden"
        },
        bottomContent: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            overflow: "auto"
        }
    };
};
var StyleConfig = {
    defaultStyles: defaultStyles
};
exports.StyleConfig = StyleConfig;
var getStyles = utilities_1.memoizeFunction(function (theme, customStyles) {
    return styling_1.concatStyleSets(StyleConfig.defaultStyles(theme || styling_1.getTheme()), customStyles);
});
exports.getStyles = getStyles;
